export default __webpack_public_path__ + "static/media/header-m-old.29204932.png";